namespace Matrix.Data {
    export enum DataType {
        String = 0,
        Int16 = 1,
        Int32 = 2,
        Int64 = 3,
        Boolean = 4,
        Decimal = 5,
        Single = 6,
        Double = 7,
        Date = 8,
        Time = 9,
        DateTime = 10,
        Guid = 11
    }
    Serenity.Decorators.registerEnumType(DataType, 'Matrix.Data.DataType');
}
